












import { Vue, Component } from 'vue-property-decorator'
import { apiPaymentRebateConfigAuthorize, apiPaymentGetTbAuthLink } from '@/api/setting'
@Component({
    components: {}
})
export default class StorageIndex extends Vue {
    /** S Data **/
    info: any = {}
    /** E Data **/

    /** S Methods **/
    init() {
        apiPaymentRebateConfigAuthorize({ code: this.$route.query.code }).then(res => {
            console.log(res);
            this.info = res
        }).catch(err => {
            console.log(err);
        })
    }
    handleBack() {
        this.$router.go(-1)
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.init()
    }
    /** E Life Cycle **/
}
